import fetchJson from '@datavant/idsb-shared/utils/fetchJson';
import { UiKit } from '@datavant/uikit';
import React, { useContext, useState } from 'react';
import useUser from '../lib/useUser';
import { useDisclosure } from '@chakra-ui/react';
import { MultiTenantModal } from './MultiTenantModal';
import { MultiTenantContext } from '../lib/contexts/MultiTenantContext';

export const UserDropdown = (): JSX.Element => {
    const currentUser = useUser();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const multiTenantContext = useContext(MultiTenantContext);

    const onLogout = async (): Promise<void> => {
        await fetchJson('/api/logout', { method: 'POST' });
        // Instead of using Next router, go through actual full page refresh so that
        // it hits Kong
        window.location.href = '/logout';
    };

    const userEmail = currentUser.user && currentUser.user.email ? currentUser.user.email : 'No user found';
    const userFirstName = currentUser.user && currentUser.user.firstName ? currentUser.user.firstName : '';
    const userLastName = currentUser.user && currentUser.user.lastName ? currentUser.user.lastName : '';
    const tenantName = multiTenantContext.tenantId
        ? `Tenant View: ${multiTenantContext.tenantName}`
        : currentUser.user?.tenantName
        ? currentUser.user.tenantName
        : '';

    return (
        <>
            {isModalOpen && <MultiTenantModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />}
            <UiKit.Chakra.Box>
                <UiKit.Chakra.Menu isOpen={isOpen}>
                    <UiKit.Chakra.MenuButton onMouseEnter={onOpen} onMouseLeave={onClose}>
                        <UiKit.Chakra.VStack spacing={0} align={'end'}>
                            <UiKit.Text.BodyRegular color={UiKit.consistency.white}>
                                {userEmail}
                            </UiKit.Text.BodyRegular>
                            <UiKit.Text.BodyRegular color={UiKit.consistency.white}>
                                {tenantName}
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.VStack>
                    </UiKit.Chakra.MenuButton>
                    <UiKit.Chakra.MenuList onMouseEnter={onOpen} onMouseLeave={onClose}>
                        <UiKit.Chakra.MenuGroup>
                            {currentUser.user && (
                                <UiKit.Chakra.VStack
                                    spacing={'0px'}
                                    align={'start'}
                                    px={UiKit.consistency.buffer}
                                >
                                    <UiKit.Text.Heading5 text={userFirstName + ' ' + userLastName} />
                                    <UiKit.Text.BodyRegular>{userEmail}</UiKit.Text.BodyRegular>
                                    {currentUser.user.tenantName && (
                                        <UiKit.Text.BodyRegular>
                                            {currentUser.user.tenantName}
                                        </UiKit.Text.BodyRegular>
                                    )}
                                    {currentUser.user.isTrueDatavanter && (
                                        <UiKit.Chakra.VStack padding={'10px 0px'} align={'start'}>
                                            <UiKit.Button.Secondary
                                                text={'Switch tenant'}
                                                isSmall={true}
                                                leftIcon={
                                                    <UiKit.Icons.FontAwesomeIcon
                                                        icon={UiKit.Icons.FontAwesome.solid.faExchange}
                                                    />
                                                }
                                                onClick={() => setIsModalOpen(true)}
                                            />
                                        </UiKit.Chakra.VStack>
                                    )}
                                </UiKit.Chakra.VStack>
                            )}
                        </UiKit.Chakra.MenuGroup>
                        <UiKit.Chakra.MenuDivider />
                        <UiKit.Chakra.MenuItem onClick={onLogout}>
                            <UiKit.Chakra.HStack>
                                <UiKit.Icons.FontAwesomeIcon
                                    icon={UiKit.Icons.FontAwesome.solid.faSignOutAlt}
                                    color={UiKit.consistency.primaryBlue50}
                                />
                                <UiKit.Text.BodyRegular color={UiKit.consistency.primaryBlue50}>
                                    Log out
                                </UiKit.Text.BodyRegular>
                            </UiKit.Chakra.HStack>
                        </UiKit.Chakra.MenuItem>
                    </UiKit.Chakra.MenuList>
                </UiKit.Chakra.Menu>
            </UiKit.Chakra.Box>
        </>
    );
};
